import { combineReducers } from 'redux';

import { Reducer } from '../../../../types';
import { StateImageList, ScriptEditorAction } from '../../types';

import { stripItems } from '../../../../../utility/store';
import {
  getImageListRequest,
  getImageListSuccess,
  getImageListFail,
  setOpenImageInstructionModal,
} from '../../actions';

type ReducerOf<T extends keyof StateImageList> = Reducer<StateImageList, ScriptEditorAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getImageListRequest.type:
      return state ? stripItems(state) : null;

    case setOpenImageInstructionModal.type:
      return action.payload ? state : null;

    case getImageListSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getImageListRequest.type:
      return true;

    case getImageListSuccess.type:
    case getImageListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateImageList>({
  data,
  loading,
});
